(function() {
  var displayQueryParam = 'display_q';

  function getSearchTerms(query) {
    return query
      .trim()
      .replace(/([A-Za-zÀ-ÿ])(\d)/g, '$1 $2')
      .replace(/(\d)([A-Za-zÀ-ÿ])/g, '$1 $2')
      .split(/\s+/)
      .map(function(term) {
        return term.replace(/[\\*"'():]/g, '');
      })
      .filter(Boolean);
  }

  function buildSearchQuery(query) {
    if (!/\s/.test(query.trim())) {
      return query.trim();
    }

    var terms = getSearchTerms(query);

    if (terms.length < 2) {
      return query.trim();
    }

    return terms.map(function(term) {
      return 'title:' + term + '*';
    }).join(' AND ');
  }

  function restoreDisplayQuery() {
    var displayQuery = new URLSearchParams(window.location.search).get(displayQueryParam);

    if (!displayQuery) {
      return;
    }

    document.querySelectorAll('form[role="search"] input[name="q"]').forEach(function(input) {
      input.value = displayQuery;
    });
  }

  document.addEventListener('DOMContentLoaded', restoreDisplayQuery);

  document.addEventListener('submit', function(event) {
    var form = event.target;

    if (!form.matches('.site-header__search-form, .search-bar--page')) {
      return;
    }

    var input = form.querySelector('input[name="q"]');
    var displayQuery = input ? input.value.trim() : '';

    if (!displayQuery) {
      return;
    }

    var params = new URLSearchParams(new FormData(form));
    params.set('q', buildSearchQuery(displayQuery));
    params.set(displayQueryParam, displayQuery);

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = form.action + '?' + params.toString();
  }, true);
})();